module.exports = __webpack_public_path__ + "static/the-last-dive-in-6744b10fe8ab3190c55ec0cc4cb68e2e.jpg";